import { createGlobalStyle } from 'styled-components';
import { typography } from '@everlywell/leaves';
import { ariesTheme } from './ariesTheme';
import { colors } from '@everlywell/leaves';

const GlobalStyle = createGlobalStyle`
  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
  */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    font-family: ${typography.type.nexa};
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-tap-highlight-color: transparent;
  }

  h1, h2 {
    font-size: 25.6px;
    font-weight: normal;
    line-height: 1.56;
    color: rgb(${ariesTheme.primaryTextColor});
  }

  h3 {
    font-size: 18px;
    font-weight: normal;
    line-height: 1.78;
    color: ${colors.black};
  }

  /* Added to Fix Footer to bottom of viewport */
  footer {
    width: 100%;
  }

  /* End Fix to Place Footer on Bottom of Viewport */

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  @media screen and (min-width: 35em) {
    html {
      margin-right: calc(-100vw + 100%);
      overflow-x: hidden;
    }
  }

  a {
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }

  blockquote, q {
    quotes: none;
  }

  blockquote::before, blockquote::after,
  q::before, q::after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }

  body {
    background: #fff;
    font-size: 100%;
    font-variant-ligatures: none;
    text-rendering: optimizeLegibility;
    font-weight: ${typography.weight.regular};
    font-family: ${typography.type.nexa};
    color: rgb(${ariesTheme.primaryTextColor});
  }

  img {
    display: block;
  	width: 100%;
  	height: auto;
  }

  button,
  input {
    font-family: inherit;
    font-size: inherit;
  }

  @keyframes delay_dismiss {
    0% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      visibility: hidden;
    }
  }

  #extole_zone_new_results_nav_bar {
    display: none;
  }

  #alert-flash {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1000000000;
    opacity: 0;
    text-align: center;
    padding: 1.2rem;
    background-color: #39b900;
    color: white;
    border-radius: 0;
    border: 0;
    margin-bottom: 0;
    animation-duration: 7s;
    animation-name: delay_dismiss;
    pointer-events: none;
    
    &.alert-success {
      background-color: #1EAAE6;
      color: white;
    }

    &.alert-info,
    &.alert-notice {
      background-color: #1EAAE6;
      color: white;
    }

    &.alert-danger,
    &.alert-error {
      background-color: #F3D1CF;
      color: #d04540;
      border: solid 1px #d04540;
    }
  }

  @font-face {
    font-family: 'Nexa-Light';
    src: url('../fonts/Nexa-Light.otf');
  }

  @font-face {
    font-family: 'Nexa-Light-Italic';
    src: url('../fonts/Nexa-Light-Italic.otf');
  }

  @font-face {
    font-family: 'Nexa-Regular';
    src: url('../fonts/Nexa-Regular.otf');
  }

  @font-face {
    font-family: 'Nexa-Regular-Italic';
    src: url('../fonts/Nexa-Regular-Italic.otf');
  }

  @font-face {
    font-family: 'Nexa-Bold';
    src: url('../fonts/Nexa-Bold.otf');
  }

  @font-face {
    font-family: 'Nexa-Bold-Italic';
    src: url('../fonts/Nexa-Bold-Italic.otf');
  }

  @font-face {
    font-family: 'Nexa-XBold';
    src: url('../fonts/Nexa-XBold.otf');
  }

  @font-face {
    font-family: 'Nexa-XBold-Italic';
    src: url('../fonts/Nexa-XBold-Italic.otf');
  }

  @font-face {
    font-family: 'Nexa-Heavy';
    src: url('../fonts/Nexa-Heavy.otf');
  }

  @font-face {
    font-family: 'Nexa-Heavy-Italic';
    src: url('../fonts/Nexa-Heavy-Italic.otf');
  }
`;

export default GlobalStyle;
